// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2RQnA","title":"AfterFrontImage_title__3FURM"};